import React, {Component} from 'react';
import configure from '../configure';

export default class ResultBox extends Component {
  constructor() {
    super();
    this.state = {
      selectedDate: null
    }
  }

  componentWillReceiveProps(nextProps){
    console.log('///get props///');
    this.setState({selectedDate: nextProps.selectedDate});
  }

  componentDidMount() {
    let option = {};

    if(configure.IS_APP()){
      option = {
        inline: true,
        maxWidth:'100%',
        onOpen: this.onOpen.bind(this)
      };
    }else if(configure.IS_PC){
      option = {
        inline: true,
        onOpen: this.onOpen.bind(this)
      };
    }else{
      option = {
        inline: true,
        maxWidth:'100%',
        onOpen: this.onOpen.bind(this)
      };
    }

    $('.popup').colorbox(option);
  }

  onOpen(e){
    console.log('onOpen',e.el);
    this.props.selectDate(e.el.getAttribute('data-id'));
  }

  sendData(e){
    const that = this;
    e.preventDefault();
    this.props.selectDate(e.currentTarget.getAttribute('data-id'));

    //TODO ugly....
    setTimeout(function() {
      that.props.sendData(that.state.selectedDate);
    }, 10);
  }

  zeropad(num) {
    return ('00'+num).slice(-2);
  }

  render() {
    return (
      <div className="result-box" style={{borderColor: this.props.data.color}}>
        <div className="title-box">
          <p className="year" style={{backgroundColor: this.props.data.color}}>{Math.floor(this.props.data.year % 100 /10)*10}'s</p>
          <p className="title">{this.props.data.month}-{this.props.data.date}</p>
        </div>

        <p className="photo">
          <img src={`/assets2/feature/peanuts/print_image/${this.props.data.year}_${this.zeropad(this.props.data.month)}_${this.zeropad(this.props.data.date)}_${this.props.data.type}.png`} alt=""/>
        </p>

        <div className="button-box">
          <p className="btn-pop">
            <a
              href="#popup"
              className="popup"
              data-id={this.props.id}
            >
              <img src="/assets2/feature/peanuts/pc/images/btn_pop.png" alt="拡大する"/>
            </a>
          </p>

          <p className="btn-cart">
            <a
              className='js-noaclink'
              href="#"
              data-id={this.props.id}
              onClick={this.sendData.bind(this)}
            >
              <img src="/assets2/feature/peanuts/pc/images/btn_cart.png" alt="カートに入れる"/>
            </a>
          </p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./source/javascripts/components/result-box.js